<template>
  <div class="flex h-full flex-grow flex-col items-center justify-center">
    <div class="bg-gradient-red flex h-14 w-14 items-center justify-center rounded-full">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="h-8 w-8 text-white">
        <path
          pathLength="1"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="1"
          d="M6 18L18 6M6 6l12 12"
          class="invisible fill-transparent"
          style="stroke-dashoffset: 0; visibility: visible" />
      </svg>
    </div>
    <h3 class="mt-6 text-center text-2xl lg:text-5xl">
      {{ $t('form.error.title') }}
    </h3>
    <!-- eslint-disable vue/no-v-html -->
    <p
      class="mt-6 max-w-xs text-center text-gray-300"
      v-html="$t('form.error.subtitle')" />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script setup lang="ts"></script>
